import { captureSentryError } from '@/lib/sentry'

/** Storage is only an optimization; unavailable storage must not abort canvas setup. */
export function consumeNewProjectMarker(projectId: string): boolean {
  let marked = false
  try {
    marked = typeof window !== 'undefined' && sessionStorage.getItem(`new-project:${projectId}`) === '1'
    if (marked) sessionStorage.removeItem(`new-project:${projectId}`)
  } catch (error) {
    captureSentryError(error, { operation: 'consumeNewProjectMarker', projectId, level: 'warning' })
  }
  return marked
}
